import { withAuthGate } from '@sunrise-ui/composites';
import IntroductionView from '@templates/IntroductionView';
import React from 'react';

function AcceptedIntroScreen() {
  return <IntroductionView />;
}

export default withAuthGate(AcceptedIntroScreen);
